import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";

export const screen_177_vat_journal_summary: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    fabAction: {
      type: "add",
      screenId: "178",
    },
    title: "VAT Journal",
    style: {
      backgroundColor: "#F9FAFB",
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12,
          padding: 16,
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "voucher_no",
            Name: "vat_journal_summary",
            BindValue: "grid_vat_journal",
            SummeryActions: [
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/vat_journal/<id>",
                },
                ActionType: "Edit",
                ScreenId: "178",
              },
              {
                Action: {
                  Action: "PDF",
                  Settings: "journal_voucher",
                },
                ActionType: ActionType.PDF_DOWNLOAD,
                tooltip: "View PDF",
              },
            ],
            Form: {
              Name: "vat_journal_summary",
              TableName: "vouchers",
              DisplayName: "vouchers",
              CheckBranch: false,
              Query:
                "SELECT vouchers.id, vouchers.voucher_no, voucher_date, SUM(voucher_details.debit) AS total_debit, SUM(voucher_details.credit) AS total_credit, SUM(COALESCE(voucher_details.vat_amount,0)) AS total_vat, users.username, vouchers.narration FROM vouchers LEFT JOIN voucher_details ON voucher_details.parent_id = vouchers.id LEFT JOIN users ON users.id = vouchers.created_by WHERE voucher_type='Journal' GROUP BY vouchers.id, vouchers.voucher_no, voucher_date, users.username, vouchers.narration",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                  IsPrimary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Voucher No.",
                  BindValue: "txt_voucher_no",
                  Json_Attribute: "voucher_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Voucher date",
                  IsMandatory: false,
                  BindValue: "txt_date",
                  Json_Attribute: "voucher_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Total debit",
                  BindValue: "txt_total_debit",
                  Json_Attribute: "total_debit",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Total credit",
                  BindValue: "txt_total_credit",
                  Json_Attribute: "total_credit",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "VAT Amount",
                  BindValue: "txt_total_vat",
                  Json_Attribute: "total_vat",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Created by",
                  BindValue: "txt_created_by",
                  Json_Attribute: "username",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Narration",
                  BindValue: "txt_narration",
                  Json_Attribute: "narration",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
